import { createContext, useContext, useEffect, useState } from "react";
import defaults from "../content/defaults.json";

const Ctx = createContext({ content: defaults, refresh: () => {}, loaded: false });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.site) {
          // merge over defaults so newly added fields never break older saved content
          const merged = {};
          for (const k of Object.keys(defaults)) {
            const incoming = data[k];
            if (Array.isArray(defaults[k])) merged[k] = Array.isArray(incoming) ? incoming : defaults[k];
            else if (incoming && typeof incoming === "object") merged[k] = { ...defaults[k], ...incoming };
            else merged[k] = incoming ?? defaults[k];
          }
          setContent(merged);
        }
      }
    } catch {} // fall back to bundled defaults so the site never breaks
    setLoaded(true);
  };

  useEffect(() => {
    refresh();
  }, []);

  return <Ctx.Provider value={{ content, refresh, loaded }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
